import $ from 'jquery'
import Plyr from 'plyr'

$(document).ready(function () {
  initPlyr()

  // SELECTIONS
  preliminaryCheckSelects()
  $('select.primary').on('change', function () {
    const categoryId = $(this).attr('data-category_id')
    const value = $('option:selected', this).val()
    changeSecondaryVisibility(categoryId, value)
    changeTableVisibility(categoryId, value)
    hideSecondary(value, categoryId)
  })
  $('select.secondary').on('change', function () {
    const selected = $('option:selected', this)
    const categoryId = $(this).attr('data-category_id')
    const folderId = selected.attr('data-folder_id')
    const value = selected.val()
    changeTableVisibility(categoryId, folderId, value)
  })

  // SEARCH
  $('input#rimadesio-search').on('keyup', function () {
    search($(this).val())
  })
  $('select.filter-arguments').on('change', function () {
    const value = $('input#rimadesio-search').val()
    search(value)
  })
  $('select.filter-types').on('change', function () {
    const value = $('input#rimadesio-search').val()
    search(value)
  })
  $('button#filters-reset').on('click', function (e) {
    e.preventDefault()
    resetFilters()
  })
  $('a.rimadesio-search-label-exit').on('click', function (e) {
    e.preventDefault()
    closeFilters()
  })

  // SORTING
  sortTable()

  // FOLDED ROWS
  manageFoldedRows()

  // VIDEO MODALS
  const searchPlayer = new Plyr('#search-video-wrapper')
  videoModals(searchPlayer)

  // CRM FORM
  $('a.order_area').on('click', function (e) {
    e.preventDefault()
    $('form#order_area').submit()
  })
  // D-COMMERCE FORM
  $('a.ecommerce_area').on('click', function (e) {
    e.preventDefault()
    $('form#ecommerce_area').submit()
  })
})

/**
 * Manage the first check on every primary and secondary select
 */
function preliminaryCheckSelects () {
  $('select.primary').each(function () {
    const categoryId = $(this).attr('data-category_id')
    const value = $('option:selected', this).val()
    changeSecondaryVisibility(categoryId, value)
    changeTableVisibility(categoryId, value)

    hideSecondary(value, categoryId)
  })
}

function hideSecondary (primaryValue, categoryId) {
  if (primaryValue === '') {
    $('select.secondary[data-category_id="' + categoryId + '"]').parent().hide()
  } else {
    $('select.secondary[data-category_id="' + categoryId + '"]').parent().show()
  }
}

/**
 * Manage secondary select options visibility
 */
function changeSecondaryVisibility (categoryId, folderId) {
  const secondary = $('select.secondary[data-category_id=' + categoryId + ']')

  // Check options data, if not present then create
  if (!secondary.data('options_' + categoryId) && typeof secondary.data('options_' + categoryId) === 'undefined') {
    secondary.data('options_' + categoryId, secondary.find('option').detach().toArray())
  }
  secondary.empty()

  $.each(secondary.data('options_' + categoryId), function () {
    if ($(this).attr('data-folder_id') === folderId) {
      secondary.append($(this))
    }
  })
  if (secondary.find('option')) {
    secondary.find('option:first').prop('selected', true)
  }
}

/**
 * Manage table visibility
 */
function changeTableVisibility (categoryId, folderId, subfolderId = undefined) {
  const folderBody = $('div[data-category_id="' + categoryId + '"]')

  const hasSecondarySelect = $('select.secondary[data-category_id="' + categoryId + '"]').length

  if (hasSecondarySelect) {
    if (subfolderId === undefined) {
      subfolderId = $('select.secondary[data-category_id="' + categoryId + '"] option:selected').val()
    }
    // Every table that has different data-folder_id (HIDE)
    folderBody.find('table[data-folder_id!="' + folderId + '"]').each(function () { $(this).hide() })

    // Every table that has equal data-folder_id (SHOW)
    folderBody.find('table[data-folder_id="' + folderId + '"]').each(function () { $(this).show() })

    if (subfolderId !== undefined) {
      folderBody.find('table[data-folder_id="' + folderId + '"]').each(function () { $(this).show() })
      // Every table that has equal data-folder_id BUT not the same data-folder_name (HIDE)
      folderBody.find('table[data-folder_id="' + folderId + '"] tr.table-row[data-folder_name!="' + subfolderId + '"]').each(function () { $(this).hide() })
      // Every table that has equal data-folder_id AND data-folder_name (SHOW)
      folderBody.find('table[data-folder_id="' + folderId + '"] tr.table-row[data-folder_name="' + subfolderId + '"]').each(function () { $(this).show() })
    }
  } else {
    // Show tables
    folderBody.find('table').each(function () { $(this).show() })

    if ((!$.isNumeric(folderId) && folderId !== '') || ($.isNumeric(folderId) && folderId.length === 4)) {
      // Hide rows
      folderBody.find('table tr.table-row[data-folder_name!="' + folderId + '"]').each(function () { $(this).hide() })
      // Show rows
      folderBody.find('table tr.table-row[data-folder_name="' + folderId + '"]').each(function () { $(this).show() })
    } else {
      // Hide rows
      folderBody.find('table[data-folder_id!="' + folderId + '"]').each(function () { $(this).hide() })
      // Show rows
      folderBody.find('table[data-folder_id="' + folderId + '"]').each(function () { $(this).show() })

      // Show subfolders tables
      folderBody.find('table.rimadesio-child-subfolder-table').each(function () { $(this).show() })
    }
  }
  if (folderId === '') {
    folderBody.find('div.empty').show()
  } else {
    folderBody.find('div.empty').hide()
  }
}

/**
 * SEARCH
 */
function search (value) {
  if (value.length) {
    $('label#rimadesio-search-label div.rimadesio-search-label-text').css('visibility', 'hidden')
  } else {
    $('label#rimadesio-search-label div.rimadesio-search-label-text').css('visibility', 'visible')
  }
  $('label#rimadesio-search-label a.rimadesio-search-label-exit').css('visibility', 'visible')

  $('div.rimadesio-folder-wrapper').hide()
  $('div.rimadesio-results-wrapper').show()
  // Show filters
  $('div.filters').show()
  // Filter search results
  filterSearchResults(value)
}

function closeFilters () {
  $('div.rimadesio-folder-wrapper').show()
  $('div.rimadesio-results-wrapper').hide()
  $('label#rimadesio-search-label a.rimadesio-search-label-exit').css('visibility', 'hidden')

  // Argument filter
  $('select.filter-arguments option[value=""]').attr('selected', true)
  $('select.filter-arguments').val('')
  // Type filter
  $('select.filter-types option[value=""]').attr('selected', true)
  $('select.filter-types').val('')
  // Search bar
  $('input#rimadesio-search').val('')
  $('label#rimadesio-search-label div.rimadesio-search-label-text').css('visibility', 'visible')

  // Hide filters
  $('div.filters').hide()
}

function filterSearchResults (value) {
  const argumentFilter = $('select.filter-arguments option:selected').val()
  const typeFilter = $('select.filter-types option:selected').val()

  let filters = ''
  if (argumentFilter.length) {
    filters += "[data-argument='" + argumentFilter + "']"
  }
  if (typeFilter.length) {
    filters += "[data-type='" + typeFilter + "']"
  }
  if (value.length) {
    filters += "[data-value*='" + value.toUpperCase() + "']"
  }

  const resultTable = $('table#search-result-table')

  // Hide all
  resultTable.find('tbody tr').hide()

  // Show filtered rows
  resultTable.find(`tbody tr${filters}`).show()

  // Change counter
  const counter = resultTable.find(`tbody tr${filters}`).size()
  $('span#filter-quantity').text(counter)

  if (counter === 0) {
    $('table#search-result-table').hide()
    $('div#no-results-found').show()
  } else {
    $('table#search-result-table').show()
    $('div#no-results-found').hide()
  }
}

function resetFilters () {
  // Argument filter
  $('select.filter-arguments option[value=""]').attr('selected', true)
  $('select.filter-arguments').val('')
  // Type filter
  $('select.filter-types option[value=""]').attr('selected', true)
  $('select.filter-types').val('')
  // Search bar
  $('input#rimadesio-search').val('')

  search('')
}

function sortTable () {
  $('table#search-result-table').find('tr.for-desktop th').on('click', function () {
    const table = $('table#search-result-table')
    let rows = table.find('tbody tr').toArray().sort(compareRows($(this).index()))
    this.asc = !this.asc
    if (!this.asc) {
      rows = rows.reverse()
    }
    for (let i = 0; i < rows.length; i++) {
      table.append(rows[i])
    }
    $('th span.table-header').eq($(this).index()).toggleClass('asc desc')
  })

  // Mobile
  $('select#mobile-table-search').on('change', function () {
    const opt = $('option:selected', this).val()
    $('table#search-result-table').find('tr.for-desktop th.' + opt).click()
  })
}

function compareRows (index) {
  return (a, b) => {
    const aValue = getCellValue(a, index)
    const bValue = getCellValue(b, index)

    return $.isNumeric(aValue) && $.isNumeric(bValue) ? aValue - bValue : aValue.toString().localeCompare(bValue)
  }
}

function getCellValue (row, index) {
  return $(row).children('td').eq(index).text()
}

function initPlyr () {
  Array.from(document.querySelectorAll('[data-video-plyr]')).map(
    p => new Plyr(p)
  )
}

function manageFoldedRows () {
  $('tr.folded td:first-child').on('click', function () {
    $(this).parent().toggleClass('open close')
  })
}

function videoModals (player) {
  $('a.search-video-link').on('click', function (e) {
    e.preventDefault()
    const videoSource = $(this).attr('data-video')
    const videoType = $(this).attr('data-video_type')

    // $('#search-video').attr('src', video)
    // $('#search-video').attr('type', type)

    player.source = {
      type: 'video',
      sources: [
        {
          src: videoSource,
          type: videoType
        }
      ]
    }

    $('div.modal').show()
  })

  // Modal close
  $('a.modal-close-link').on('click', function (e) {
    e.preventDefault()
    player.stop()
    $('div.modal').hide()
  })
}
